import type { PageType } from '@haaretz/s-types';

export default function articleTypeValidator(articleType: PageType): boolean {
  if (typeof articleType !== 'string') return false;

  return articleType.endsWith('Article');
}
